import { useEffect } from "react";
import ImageWrapper from "@components/ui-components/image-wrapper";
import useAxios from "@hooks/use-axios";
import { useNavigate } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";
import { useTranslation } from "react-i18next";

const GoogleAuthVerify = () => {
    
    const navigate = useNavigate();

    const { axiosInstance } = useAxios({
        base: "panel"
    });
    const { getSearchParams } = useSearchParams();
    const code = getSearchParams("code");
    const { t } = useTranslation();
    const loginWithGoogle = async () => {
        try {
            const { data } = await axiosInstance.get("/user/login", {
                params: { code }
            });
            
            navigate(`/verify/two-factor-auth?verification_token=${data.verification_token}`);
        } catch (error) {
            navigate("/login");
        }
    };

    useEffect(() => {
        loginWithGoogle();
    }, [code]);

    return (
        <h2 className="text-center m-3">
            <ImageWrapper
                className="img-fluid"
                id="wait-clock"
                src={"common/wait-clock.png"}
                alt="wait-clock"
                width={300}/>
            <br />
            <p className="mt-3"> {t("Please wait until verifying token...")}</p>
        </h2>
    );
};

export default GoogleAuthVerify;
